import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'muni-gameday-order-number',
  styleUrls: ['./order-number.styles.scss'],
  template: `
    <div class="order-number-container" *ngIf="order">
      <span
        class="order-number"
        [textContent]="order.orderNumber | number: '1.0-2'"
        title="{{ order.orderNumber | number: '1.0-2' }}"
      >
      </span>
      <muni-gameday-comment [text]="order.comments" class="comments">
      </muni-gameday-comment>
    </div>
  `
})
export class OrderNumberComponent implements ICellRendererAngularComp {
  private params: ICellRendererParams;
  public order;

  public agInit(params: ICellRendererParams) {
    this.params = params;
    this.order = this.params.data;
  }

  public refresh(): boolean {
    return false;
  }
}
